import { createFileRoute } from "@tanstack/react-router";
import { RelatorioCadastroProdutor } from "pages/relatorios/pages/cadastro_produtor";

export const Route = createFileRoute("/a/relatorios/cadastro-produtor")({
	component: RelatorioCadastroProdutor,
});
